'use client';

import { ComponentPropsWithRef, ComponentRef, forwardRef } from 'react';
import { Link as NavLink } from '@/i18n/routing';

type Props = ComponentPropsWithRef<typeof NavLink>;

/**
  Any external links
 */
export const ExternalLink = forwardRef<ComponentRef<'a'>, Props>(
  ({ href, children, className }, ref) => {
    const hrefString = typeof href === 'string' ? href : href.href;
    if (!hrefString) {
      return null;
    }
    const link = new URL(hrefString).toString();
    return (
      <a className={className} href={link} target='_blank' ref={ref}>
        {children}
      </a>
    );
  },
);

ExternalLink.displayName = 'ExternalLink';
